/**
 * Professional.jsx — Annotator's own profile page.
 * Route: /profile
 *
 * Renders the same personal-info form that SPL/Admin use at /admin/profile —
 * editable name, phone, timezone, bio, LinkedIn. Email is read-only.
 * Metrics, charts, and project history live on Dashboard, My Work, Earnings.
 */
import MyProfile from './admin/MyProfile';

export default function Professional() {
  return <MyProfile />;
}
